<template>
  <div class="subpage" ref="totalRef">
    <Header v-if="$route.query.platform !== 'mini'" ref="navBarRef" title="姓名吉凶" :is-sub-page="true"></Header>
    <div ref="resultRef" class="result">
      <cube-scroll>
        <div class="sub-title">
          <p>五格数理</p>
        </div>
        <div class="sub-result">
          <div class="part1">{{this.relations.count}} 外格</div>
          <div class="part2">({{this.relations.elements}})&nbsp;<nobr>{{this.relations.goodBad}}</nobr></div>
          <div class="part3">
            <div :class="[this.firstNameTxt.text[0].trim().length==0?'emptyName':'firstName']">{{this.firstNameTxt.text[0]}}</div>
            <div :class="[this.firstNameTxt.text[1].trim().length==0?'emptyName':'firstName']">{{this.firstNameTxt.text[1]}}</div>
            <div :class="[this.lastNameTxt.text[0].trim().length==0?'emptyName':'lastName']">{{this.lastNameTxt.text[0]}}</div>
            <div :class="[this.lastNameTxt.text[1].trim().length==0?'emptyName':'lastName']">{{this.lastNameTxt.text[1]}}</div>
          </div>
          <div class="part4">
            <div class="number">{{this.firstNameTxt.stroke[0]}}</div>
            <div class="number">{{this.firstNameTxt.stroke[1]}}</div>
            <div class="number">{{this.lastNameTxt.stroke[0]}}</div>
            <div class="number">{{this.lastNameTxt.stroke[1]}}</div>
          </div>
          <div class="part5">
            <div class="arrow-right"></div>
            <div class="arrow-right"></div>
            <div class="arrow-right"></div>
          </div>
          <div class="part6">
            <div class="summary">
              {{this.sky.count}} 天格 ({{this.sky.elements}}) <span class="color-purple">{{this.sky.goodBad}}</span>
            </div>
            <div class="summary">
              {{this.man.count}} 人格 ({{this.man.elements}}) <span class="color-purple">{{this.man.goodBad}}</span>
            </div>
            <div class="summary">
              {{this.land.count}} 地格 ({{this.land.elements}}) <span class="color-purple">{{this.land.goodBad}}</span>
            </div>
          </div>
          <div class="part7"></div>
          <div class="part8">
            {{this.overall.count}} 总格 ({{this.overall.elements}}) <span class="color-purple">{{this.overall.goodBad}}</span>
          </div>
        </div>
        <div class="sub-title">
          <p>五格剖析</p>
        </div>
        <div class="list" @click="changeShow(0)">
          <div>
            <p>天格分析</p>
            <img :src="arrowDown"  v-if="!showContent[0]"/>
            <img :src="arrowUp"  v-if="showContent[0]"/>
          </div>
        </div>
        <div class="list-content" v-if="showContent[0]" >
          <ul>
            <li>
              <div class="dot"></div>
              <div class="label">总格理数: <nobr>{{this.sky.count}}</nobr></div>
            </li>
            <SpaceHolder spaceheight="2"></SpaceHolder>
            <li>
              <div class="dot"></div>
              <div class="label">数理吉凶: <nobr>{{this.sky.goodBad}}</nobr></div>
            </li>
            <SpaceHolder spaceheight="2"></SpaceHolder>
            <li>
              <div class="dot"></div>
              <div class="label">数理简评: <nobr>{{this.sky.comment}}</nobr></div>
            </li>
          </ul>
          <SpaceHolder spaceheight="10" ></SpaceHolder>
          <div class="border-between"></div>
          <SpaceHolder spaceheight="10" ></SpaceHolder>
          <h3>数理解析</h3>
          <SpaceHolder spaceheight="0" ></SpaceHolder>
          <h4>{{this.sky.parsing}}</h4>
        </div>
        <SpaceHolder spaceheight="0"></SpaceHolder>
        <div class="list"  @click="changeShow(1)">
          <div>
            <p>人格分析</p>
            <img :src="arrowDown" v-if="!showContent[1]"/>
            <img :src="arrowUp"  v-if="showContent[1]"/>
          </div>
        </div>
        <div class="list-content" v-if="showContent[1]" >
          <ul>
            <li>
              <div class="dot"></div>
              <div class="label">总格理数: <nobr>{{this.man.count}}</nobr></div>
            </li>
            <SpaceHolder spaceheight="2"></SpaceHolder>
            <li>
              <div class="dot"></div>
              <div class="label">数理吉凶: <nobr>{{this.man.goodBad}}</nobr></div>
            </li>
            <SpaceHolder spaceheight="2"></SpaceHolder>
            <li>
              <div class="dot"></div>
              <div class="label">数理简评: <nobr>{{this.man.comment}}</nobr></div>
            </li>
          </ul>
          <SpaceHolder spaceheight="10" ></SpaceHolder>
          <div class="border-between"></div>
          <SpaceHolder spaceheight="10" ></SpaceHolder>
          <h3>数理解析</h3>
          <SpaceHolder spaceheight="0" ></SpaceHolder>
          <h4>{{this.man.parsing}}</h4>
        </div>
        <SpaceHolder spaceheight="0"></SpaceHolder>
        <div class="list" @click="changeShow(2)">
          <div>
            <p>地格分析</p>
            <img :src="arrowDown"  v-if="!showContent[2]"/>
            <img :src="arrowUp"  v-if="showContent[2]"/>
          </div>
        </div>
        <div class="list-content" v-if="showContent[2]" >
          <ul>
            <li>
              <div class="dot"></div>
              <div class="label">总格理数: <nobr>{{this.land.count}}</nobr></div>
            </li>
            <SpaceHolder spaceheight="2"></SpaceHolder>
            <li>
              <div class="dot"></div>
              <div class="label">数理吉凶: <nobr>{{this.land.goodBad}}</nobr></div>
            </li>
            <SpaceHolder spaceheight="2"></SpaceHolder>
            <li>
              <div class="dot"></div>
              <div class="label">数理简评: <nobr>{{this.land.comment}}</nobr></div>
            </li>
          </ul>
          <SpaceHolder spaceheight="10" ></SpaceHolder>
          <div class="border-between"></div>
          <SpaceHolder spaceheight="10" ></SpaceHolder>
          <h3>数理解析</h3>
          <SpaceHolder spaceheight="0" ></SpaceHolder>
          <h4>{{this.land.parsing}}</h4>
        </div>
        <SpaceHolder spaceheight="0"></SpaceHolder>
        <div class="list" @click="changeShow(3)">
          <div>
            <p>外格分析</p>
            <img :src="arrowDown" v-if="!showContent[3]"/>
            <img :src="arrowUp"  v-if="showContent[3]"/>
          </div>
        </div>
        <div class="list-content" v-if="showContent[3]" >
          <ul>
            <li>
              <div class="dot"></div>
              <div class="label">总格理数: <nobr>{{this.relations.count}}</nobr></div>
            </li>
            <SpaceHolder spaceheight="2"></SpaceHolder>
            <li>
              <div class="dot"></div>
              <div class="label">数理吉凶: <nobr>{{this.relations.goodBad}}</nobr></div>
            </li>
            <SpaceHolder spaceheight="2"></SpaceHolder>
            <li>
              <div class="dot"></div>
              <div class="label">数理简评: <nobr>{{this.relations.comment}}</nobr></div>
            </li>
          </ul>
          <SpaceHolder spaceheight="10" ></SpaceHolder>
          <div class="border-between"></div>
          <SpaceHolder spaceheight="10" ></SpaceHolder>
          <h3>数理解析</h3>
          <SpaceHolder spaceheight="0" ></SpaceHolder>
          <h4>{{this.relations.parsing}}</h4>
        </div>
        <SpaceHolder spaceheight="0"></SpaceHolder>
        <div class="list" @click="changeShow(4)">
          <div>
            <p>总格分析</p>
            <img :src="arrowDown"  v-if="!showContent[4]"/>
            <img :src="arrowUp"  v-if="showContent[4]"/>
          </div>
        </div>
        <div class="list-content" v-if="showContent[4]" >
          <ul>
            <li>
              <div class="dot"></div>
              <div class="label">总格理数: <nobr>{{this.overall.count}}</nobr></div>
            </li>
            <SpaceHolder spaceheight="2"></SpaceHolder>
            <li>
              <div class="dot"></div>
              <div class="label">数理吉凶: <nobr>{{this.overall.goodBad}}</nobr></div>
            </li>
            <SpaceHolder spaceheight="2"></SpaceHolder>
            <li>
              <div class="dot"></div>
              <div class="label">数理简评: <nobr>{{this.overall.comment}}</nobr></div>
            </li>
          </ul>
          <SpaceHolder spaceheight="10" ></SpaceHolder>
          <div class="border-between"></div>
          <SpaceHolder spaceheight="10" ></SpaceHolder>
          <h3>数理解析</h3>
          <SpaceHolder spaceheight="0" ></SpaceHolder>
          <h4>{{this.overall.parsing}}</h4>
        </div>
        <SpaceHolder spaceheight="0"></SpaceHolder>
        <div class="list" @click="changeShow(5)">
          <div>
            <p>三才分析</p>
            <img :src="arrowDown"  v-if="!showContent[5]"/>
            <img :src="arrowUp" v-if="showContent[5]"/>
          </div>
        </div>
        <div class="list-content" v-if="showContent[5]" >
          <SpaceHolder spaceheight="10" ></SpaceHolder>
          <h3>{{this.getSkyMan()}}</h3>
          <SpaceHolder spaceheight="0" ></SpaceHolder>
          <h4>{{this.ability.sky_man.content}}</h4>
          <SpaceHolder spaceheight="10" ></SpaceHolder>
          <div class="border-between"></div>
          <SpaceHolder spaceheight="10" ></SpaceHolder>
          <h3>{{this.getManLand()}}</h3>
          <SpaceHolder spaceheight="0" ></SpaceHolder>
          <h4>{{this.ability.man_land.content}}</h4>

          <SpaceHolder spaceheight="10" ></SpaceHolder>
          <div class="border-between"></div>
          <SpaceHolder spaceheight="10" ></SpaceHolder>
          <h3>{{this.getSkyLand()}}</h3>
          <SpaceHolder spaceheight="0" ></SpaceHolder>
          <h4>{{this.ability.sky_land.content}}</h4>

        </div>
        <SpaceHolder spaceheight="0"></SpaceHolder>
      </cube-scroll>
    </div>
  </div>
</template>

<script>
import Header from '@/components/Header'
import SpaceHolder from '../../components/SpaceHolder'
import { queryName } from '@/api/test'
export default {
  name: 'Result',
  components: {
    Header,
    SpaceHolder
  },
  data () {
    return {
      arrowDown: require('@/assets/images/icons/icon-down-arrow.png'),
      arrowUp: require('@/assets/images/icons/icon-up-arrow.png'),
      showContent: [false, false, false, false, false, false],
      Contents: ['111', '222', '333', '444', '555', '666'],
      isShow: 0,
      firstName: '',
      lastName: '',
      sex: '',
      firstNameTxt: {
        text: ['', ''],
        stroke: ['0', '0']
      },
      lastNameTxt: {
        text: ['', ''],
        stroke: ['', '']
      },
      sky: {
        comment: '',
        count: '',
        elements: '',
        goodBad: '',
        parsing: ''
      }, // 天格
      land: {
        comment: '',
        count: '',
        elements: '',
        goodBad: '',
        parsing: ''
      }, // 地格
      man: {
        comment: '',
        count: '',
        elements: '',
        goodBad: '',
        parsing: ''
      }, // 人格
      relations: {
        comment: '',
        count: '',
        elements: '',
        goodBad: '',
        parsing: ''
      }, // 外格
      overall: {
        comment: '',
        count: '',
        elements: '',
        goodBad: '',
        parsing: ''
      }, // 总格

      ability: {// 三才
        sky_man: {// 天格人格
          content: '',
          relationship: '',
          order: ''
        },
        man_land: {// 人格地格
          content: '',
          relationship: '',
          order: ''
        },
        sky_land: {// 天格地格
          content: '',
          relationship: '',
          order: ''
        }

      }

    }
  },
  mounted () {
    console.log('mounted luck  result')

    this.$nextTick(() => {
      const navBarHeight = this.$refs.navBarRef ? this.$refs.navBarRef.$el.clientHeight : 0
      this.$refs.resultRef.style.height = (this.$refs.totalRef.clientHeight - navBarHeight) + 'px'
    })

    console.log('firstName=' + this.$route.query.firstName + '  secName=' + this.$route.query.lastName + '  sex=' + this.$route.query.sex)
    this.firstName = this.$route.query.firstName
    this.lastName = this.$route.query.lastName
    this.sex = this.$route.query.sex
    this.getData()
    console.log('mounted luck result finish')
  },
  methods: {
    // 控制展示某个折叠面板
    changeShow (located) {
      // 如果点击的折叠面板已经展开，隐藏所有面板
      if (this.showContent[located] === true) {
        this.showContent = [false, false, false, false, false, false]
        return
      }
      // 如果点击其他的折叠面板，先展开点击面板，再隐藏已开面板
      this.showContent.filter((item, index) => {
        if (item === true) {
          this.$set(this.showContent, located, true)
          this.$set(this.showContent, index, false)
        }
      })
      this.$set(this.showContent, located, true)
    },
    getData () {
      queryName({
        firstName: this.firstName,
        secondName: this.lastName,
        sexCode: this.sex
      }).then((res) => {
        // 笔画
        if (res.data.firstName.length === 1) {
          this.firstNameTxt = {
            text: ['', res.data.firstName[0].text],
            stroke: ['+1', res.data.firstName[0].stroke]
          }
        } else if (res.data.firstName.length > 1) {
          // const f1 = this.firstName.slice(0,1)
          // const f2 = this.firstName.slice(1,2)
          const f1 = res.data.firstName[0].text
          const f2 = res.data.firstName[1].text
          console.log('f1=' + f1 + '  f2=' + f2)
          this.firstNameTxt = {
            text: [f1, f2],
            stroke: [res.data.firstName[0].stroke, res.data.firstName[1].stroke]
            // stroke:[f1.stroke(),f2.stroke()]
          }
        }
        if (res.data.secondName.length === 1) {
          this.lastNameTxt = {
            text: [res.data.secondName[0].text, ''],
            stroke: [res.data.secondName[0].stroke, '+1']
          }
        } else if (res.data.secondName.length > 1) {
          const f1 = res.data.secondName[0].text
          const f2 = res.data.secondName[1].text
          this.lastNameTxt = {
            text: [f1, f2],
            stroke: [res.data.secondName[0].stroke, res.data.secondName[1].stroke]
          }
        }

        console.log('123  get res ok')
        // 三才
        this.ability = {
          sky_man: this.getAbility({
            res: res,
            code: '0'
          }),
          man_land: this.getAbility({
            res: res,
            code: '1'
          }),
          sky_land: this.getAbility({
            res: res,
            code: '2'
          })
        }
        console.log('sky_man    ' + this.ability.sky_man)

        this.sky.comment = res.data.sky.comment
        this.sky.count = res.data.sky.count
        this.sky.elements = res.data.sky.elements
        this.sky.goodBad = res.data.sky.goodBad
        this.sky.parsing = res.data.sky.parsing
        this.land.comment = res.data.land.comment
        this.land.count = res.data.land.count
        this.land.elements = res.data.land.elements
        this.land.goodBad = res.data.land.goodBad
        this.land.parsing = res.data.land.parsing
        this.man.comment = res.data.man.comment
        this.man.count = res.data.man.count
        this.man.elements = res.data.man.elements
        this.man.goodBad = res.data.man.goodBad
        this.man.parsing = res.data.man.parsing
        this.relations.comment = res.data.relations.comment
        this.relations.count = res.data.relations.count
        this.relations.elements = res.data.relations.elements
        this.relations.goodBad = res.data.relations.goodBad
        this.relations.parsing = res.data.relations.parsing
        this.overall.comment = res.data.overall.comment
        this.overall.count = res.data.overall.count
        this.overall.elements = res.data.overall.elements
        this.overall.goodBad = res.data.overall.goodBad
        this.overall.parsing = res.data.overall.parsing
        // this.land = res.data.land
        // this.man = res.data.man
        // this.relations = res.data.relations
        // this.overall = res.overall
        console.log('三才获取完毕')
      })
    },
    getAbility (data) {
      const res = data.res
      const code = data.code

      var tmp = null
      res.data.ability.forEach((item, idx) => {
        console.log('getAbility   code=' + code + '   abCode=' + item.abilityCode)

        if (item.abilityCode.trim() === code.trim()) {
          console.log('== return')

          tmp = {
            content: item.content,
            relationship: this.getRelationship(item.relationshipCode),
            order: item.order
          }
        }
      })
      return tmp
    },
    getRelationship (code) {
      var tmp = ''
      switch (code) {
        case '0':
          tmp = '生'
          break
        case '1':
          tmp = '克'
          break
        case '2':
          tmp = '合'
          break
      }
      return tmp
    },
    compare (attr) {
      return function (a, b) {
        var val1 = a[attr]
        var val2 = b[attr]
        return val1 - val2
      }
    },
    getSkyMan () {
      if (this.ability.sky_man.order === '0') {
        return '天格' + this.ability.sky_man.relationship + '人格'
      } else {
        return '人格' + this.ability.sky_man.relationship + '天格'
      }
    },
    getManLand () {
      return this.ability.man_land.order === '0'
        ? '人格' + this.ability.man_land.relationship + '地格' : '地格' + this.ability.man_land.relationship + '人格'
    },
    getSkyLand () {
      return this.ability.sky_land.order === '0'
        ? '天格' + this.ability.sky_land.relationship + '地格' : '地格' + this.ability.sky_land.relationship + '天格'
    }
  },
  computed: {
    refList () {
      const refList = {
        totalRef: this.$refs.totalRef.clientHeight,
        resultRef: this.$refs.resultRef,
        headerRef: this.$refs.headerRef.$el.clientHeight
      }
      return refList
    }
  }
}
</script>

<style lang="stylus" scoped>
.subpage
  background url("~@/assets/images/backgrounds/bg.png") no-repeat center
  background-size 100% 100%
  .result
    padding 0 15px
    .sub-title
      width 100%
      height 22px
      line-height 22px
      margin 12px 0
      font-size 15px
      font-weight 400
      text-align start
      color #FDFDFD
    .sub-result
      width 100%
      height 217px
      background #fff
      position relative
      box-sizing border-box
      padding 22px 15px 12px 15px
      .part1, .part2, .part3, .part4, .part5, .part6, .part7, .part8
        position absolute
      .part1, .part2
        font-size 12px
        font-weight 500
        color #545454
      .part3, .part4
        font-size 15px
        font-weight 400
        color #545454
        line-height 21px
      .part3, .part4, .part5, .part6
        display flex
        flex-direction column
      .part1
        top 110px
        left 15px
      .part2
        top 131.5px
        left 15px
      .part3
        top 22px
        left 100px
        width 24px
        height 126px
        .firstName
          width 24px
          height 24px
          margin auto
          border-radius 50%
          background #D2B6F7
          display flex
          justify-content center
          align-items center
        .lastName
          width 24px
          height 24px
          margin auto
          border-radius 50%
          background #D6CFE0
          display flex
          justify-content center
          align-items center
        .emptyName
          width 24px
          height 24px
          margin auto
          border-radius 50%
          display flex
          justify-content center
          align-items center
      .part4
        top 22px
        left 153.5px
        width 24px
        height 126px
        .number
          width 24px
          height 24px
          margin auto
      .part5
        top 34px
        left 181px
        width 25px
        height 102px
        .arrow-right
          width 24px
          height 30px
          margin auto
          background url("~@/assets/images/icons/icon-greater-than.png") no-repeat center
          background-size 25px
      .part6
        top 34px
        left 216px
        height 102px
        .summary
          height 16.5px
          margin auto
          font-size 12px
          font-weight 500
          color #545454
          line-height 16.5px
      .part7
        top 170px
        width calc(100% - 30px)
        height 2px
        background #874dd5
      .part8
        top 184px
        left 113.5px
        height 21px
        font-size 15px
        font-weight 500
      nobr
        font-size 12px
        font-weight 500
        color #874dd5
    .list
      width 100%
      height 60px
      display flex
      align-items center
      background #fff
      box-sizing border-box
      padding 19.5px 23px 19.5px 15px
      div
        width 100%
        height 14px
        border-left 2px solid #874dd5
        border-raduis 2px
        position relative
        text-align end
        p
          position absolute
          left 3.5px
          font-size 15px
          color #545454
          font-weight 400
        img
          vertical-align: middle
          width 15px
          height 9px
    .list-content
      width 100%
      background #fff
      text-align start
      box-sizing border-box
      padding 2px 22px 22px 22px
      margin-top -3px
      li
        display flex
        flex-direction row
        align-items center
      .dot
        width 7px
        height 7px
        background #874dd5
        border-radius 50%
      .label
        margin-left 7px
        font-size 15px
        font-weight 400
      .border-between
        width 100%
        height 1px
        background #DDDDDD
      h3, h4, nobr
        font-size 15px
        font-weight 400
      h3
        color #545454
      h4
        line-height 21px
      nobr
        color #874dd5
</style>

<style lang="stylus">
body
  background-color #EFE9E0
</style>
